export default __webpack_public_path__ + "static/media/logoSVG.9a4643f6.svg";